export default "assets/fec5c0e503d60b715bff3126bdff5272.png";